import type { TenantTheme } from "./tenants";

/**
 * Pushes the tenant colours into the CSS custom properties that Tailwind's
 * `brand` utilities read (see `index.css`), and sets tab title and favicon.
 *
 * Called before React renders so there is no flash of the default theme.
 */
export function applyTenantTheme(tenant: TenantTheme) {
	const { style, dataset } = document.documentElement;

	style.setProperty("--color-brand", tenant.colors.primary);
	style.setProperty("--color-brand-foreground", tenant.colors.onPrimary);
	style.setProperty("--color-brand-secondary", tenant.colors.secondary);
	style.setProperty("--color-app-background", tenant.colors.background);

	dataset.tenant = tenant.key;

	document.title = `${tenant.name} kundwebb`;

	if (tenant.favicon) {
		const link =
			document.querySelector<HTMLLinkElement>("link[rel~='icon']") ??
			document.head.appendChild(Object.assign(document.createElement("link"), { rel: "icon" }));

		link.href = tenant.favicon;
	}
}
